import { ServiceParameterEnum } from "@monorepo/types";

export const getTotalSum = (params: { [key: string]: string }) => {
  const amountParams = Object.keys(params).filter(
    (param) => /AMT[0-9]*/.test(param) && param.startsWith(ServiceParameterEnum.AMT)
  );
  let totalSum = 0;
  amountParams.forEach((param) => {
    totalSum += Number(params[param]);
  });
  return totalSum;
};
